import BillingsCargoTaxiDetailsRequest from "../../../../api/raily/billings/cargo-taxi/details/billings-cargo-taxi-details.request";
import BillingsCargoTaxiDetailsParams from "./billings-cargo-taxi-details-params";

const create = (
  params: BillingsCargoTaxiDetailsParams,
): BillingsCargoTaxiDetailsRequest => {
  return {
    billingUuid: params.billingUuid,
  };
};

const billingsCargoTaxiDetailsParamsFactory = {
  create,
};

export default billingsCargoTaxiDetailsParamsFactory;
